import PopupAuthModule from '@oarepo/vue-popup-login'
// import EventBus from '../eventbus';

export default ({ app, Vue }) => {
  let apiURL = process.env.VUE_APP_OAREPO_API_URL
  if (!apiURL.endsWith('/')) {
    apiURL += '/'
  }

  Vue.use(PopupAuthModule, {
    store: app.store,
    authStateURL: `${apiURL}auth/state`,
    authLoginURL: `${apiURL}auth/login`,
    authLogoutURL: `${apiURL}auth/logout`,
    popupBlockedCallback: () => {
      app.store._vm.notify$({
        message: 'Please allow popups for login'
      })
    }
    // iframeCreator: (loginURL) => {
    //     EventBus.$emit('createLoginDialog', loginURL);
    //     return () => {
    //         EventBus.$emit('destroyLoginDialog');
    //     };
    // },
  })
}
